import './Text.css';
import SuperSonicMP4 from './Supersonic.mp4'
import React, { useState } from 'react';


export function SuperSonic() {
    const [LM0QIgkKlcQ] = useState('LM0QIgkKlcQ')
  return (
    <div class="body">
            <div class="row" >




<iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${LM0QIgkKlcQ}?autoplay=0`}>
</iframe>




      
      </div>      </div>

  );
}
